import { Button, Paper, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { api, } from "../api";
import InfoModal from "../components/InfoModal";
import { AgreementCheckbox } from "./AgreementCheckbox";
import { useOrderParams } from "./useOrderParams";
import { OrderParamsForm } from "./OrderParamsForm";

interface CamerasFormProps {
    onClose: () => void;
}

const CamerasForm: React.FC<CamerasFormProps> = ({ onClose }) => {
    const { t } = useTranslation();
    const [isAgreementAccepted, setIsAgreementAccepted] = useState(false);
    const [kind, setKind] = useState<'offer' | 'privacy'>('offer');
    const [isModalOpen, setIsModalOpen] = useState(false);
    
    const orderParams = useOrderParams({mode: 'EndDate'});
    const { camerasAnalytics, camerasSimple, camerasAnalyticsFact, camerasSimpleFact } = orderParams;
    
    useEffect(() => {
        console.log("Данные обновились:", { 
            camerasAnalytics, 
            camerasAnalyticsFact, 
            camerasSimple, 
            camerasSimpleFact 
        });
    }, [camerasAnalytics, camerasAnalyticsFact, camerasSimple, camerasSimpleFact]);

    const handleOpen = (kind: 'offer' | 'privacy') => {
        setIsModalOpen(true);
        setKind(kind);
    }

    const handleAccept = () => {
        setIsAgreementAccepted(true);
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsAgreementAccepted(false);
        setIsModalOpen(false);
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        
        if (!isAgreementAccepted) {
            alert(t('OrderForm.PleaseAcceptAgreement'));
            return;
        }

        if (camerasAnalyticsFact > camerasAnalytics ) {
            alert('Кількість активних камер з аналітикою перевищує Кількість замовлених');
            return;
        }

        if (camerasSimpleFact > camerasSimple ) {
            alert('Кількість активних камер без аналітики перевищує Кількість замовлених');
            return;
        }

        const order = await api.postPreInvoiceNoPay({camerasAnalytics, camerasSimple});
        if (!order) {
            alert('Помилка при створенні замовлення');
            return;
        }
        onClose();
    };

    return (
        <Paper elevation={3} sx={{ maxWidth: 420, mx: "auto", p: 3, mt: 4 }}>
            <form onSubmit={handleSubmit}>
                <Typography variant="h5" gutterBottom>
                    Зміна кількості камер
                </Typography>

                <OrderParamsForm 
                    {...orderParams}
                    hidePeriod={true}
                    hideCurrency={true}
                />
                
                <AgreementCheckbox
                    checked={isAgreementAccepted}
                    onChange={(checked) => setIsAgreementAccepted(checked)}
                    onOpenOffer={() => handleOpen('offer')}
                    onOpenPrivacy={() => handleOpen('privacy')}
                />

                <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ fontWeight: "bold", px: 4 }}
                        disabled={!isAgreementAccepted}
                    >
                        {/* {t('OrderForm.ChangeButton')} */}
                        Змінити
                    </Button>
                    <Button
                        type="button"
                        onClick={onClose}
                        variant="outlined"
                        color="secondary"
                    >
                        {t('OrderForm.ExitButton')}
                    </Button>
                </Stack>
            </form>
            
            <InfoModal
                open={isModalOpen}
                onCancel={handleCancel}
                onAccept={handleAccept}
                kind={kind}
            />
        </Paper>
    );
};

export default CamerasForm;
